"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const withStyles_1 = require("@material-ui/core/styles/withStyles");
const withTheme_1 = require("@material-ui/core/styles/withTheme");
const React = require("react");
const react_i18next_1 = require("react-i18next");
const InformationDialog_1 = require("../dialog/InformationDialog");
const LoadError_1 = require("../load-error/LoadError");
const InteractiveGameStyle_1 = require("./jss/InteractiveGameStyle");
const INITIAL_STATE = {
    loading: false
};
class VideoModal extends React.Component {
    constructor(props) {
        super(props);
        this.hideSpinner = () => {
            this.setState({
                loading: false
            });
        };
        this.renderIframe = () => {
            const { classes, videoUrl } = this.props;
            return (0, jsx_runtime_1.jsx)("iframe", { src: videoUrl, id: 'iframe', className: classes.iframe, onLoad: this.hideSpinner, allow: "autoplay" });
        };
        this.matchYoutubeUrl = (url) => {
            const pattern = /^(http(s)?:\/\/)?((w){3}.)?youtu(be|.be)?(\.com)?\/.+/;
            return pattern.test(url);
        };
        this.state = Object.assign({}, INITIAL_STATE);
    }
    render() {
        if (this.props.videoUrl === undefined) {
            return null;
        }
        return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: (0, jsx_runtime_1.jsx)(InformationDialog_1.default, Object.assign({ open: this.props.launchVideo, hideButton: true, maxWidth: 'lg', noSpaces: true, gameView: true, onClose: this.props.onClose, reducedWidth: true }, { children: this.matchYoutubeUrl(this.props.videoUrl) ? (this.renderIframe()) : ((0, jsx_runtime_1.jsx)(LoadError_1.default, { text: "Something went wrong while loading the content!" })) })) }));
    }
}
exports.default = (0, withTheme_1.default)((0, withStyles_1.default)(InteractiveGameStyle_1.default)((0, react_i18next_1.withTranslation)()(VideoModal)));
//# sourceMappingURL=VideoModal.js.map